function isMissingChunkErrorMessage(error: Error): boolean {
  const msg = error.message || "";
  return /dynamic.*import.*module/gim.test(msg);
}

export default isMissingChunkErrorMessage;
